import Immutable from 'seamless-immutable'

import { SET_CAROUSEL_IMAGES, CLEAR_CAROUSEL_IMAGES } from './actions'

const initialState = Immutable.from({
  carousel: {
    images: [],
    activeIndex: null,
  },
})

export const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CAROUSEL_IMAGES:
      return state.set('carousel', payload)
    case CLEAR_CAROUSEL_IMAGES:
      return state.set('carousel', initialState.carousel)
    default:
      return state
  }
}
